import useNavigator from "@saleor/hooks/useNavigator";
import React from "react";

import ResetPasswordInvalidPage from "../components/ResetPasswordInvalidPage";
import { passwordResetPath } from "../urls";

const ResetPasswordInvalidView: React.FC = () => {
  const navigate = useNavigator();

  return (
    <ResetPasswordInvalidPage onBack={() => navigate(passwordResetPath)} />
  );
};
export default ResetPasswordInvalidView;
